import React, { useState } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import { addVesselTypeMastersList } from "../../../redux/actions/mastersAction";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const AddDefectMasterModel = (Props) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.user?.userData);

  const [AddVesselType, SetAddVesselType] = React.useState("");

  const handleChangeAddVesselType = (event) => {
    SetAddVesselType(event.target.value);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (AddVesselType !== "") {
      dispatch(
        addVesselTypeMastersList({
          name: AddVesselType,
          company_id: userData?.company_id,
        })
      );
      Props.handleCloseAddVesselTypeMasterModel();
    } else {
      toast.error("Please enter Vessel Type Name");
    }
  };

  return (
    <Modal
      open={Props.isAddDefectMaster}
      onClose={() => Props.handleCloseAddDefectMaster}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add Defect Question
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={Props.handleCloseAddDefectMaster}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Add Defect Question"
                type="text"
                value={AddVesselType}
                onChange={handleChangeAddVesselType}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", 
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"

                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={Props.handleCloseAddDefectMaster}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <Button
                // variant="contained"
                onClick={onSubmit}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddDefectMasterModel;
